<!--
  ~ Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
  ~ This software is released under MIT license.
  ~ The full license information can be found in LICENSE in the root directory of this project.
  -->

<h4 cds-text="subsection medium" class="clr-mt-32px">Top-Right</h4>
<div class="clr-example squeeze example-center">
  <a
    href="javascript://"
    role="tooltip"
    aria-haspopup="true"
    class="tooltip tooltip-sm tooltip-top-right"
    aria-label="top right direction"
  >
    <cds-icon shape="info-circle" size="24"></cds-icon>
    <span class="tooltip-content">Lorem ipsum sit</span>
  </a>
</div>
<app-code-snippet [code]="example1"></app-code-snippet>

<h4 cds-text="subsection medium" class="clr-mt-32px">Top-Left</h4>
<div class="clr-example squeeze example-center">
  <a
    href="javascript://"
    role="tooltip"
    aria-haspopup="true"
    class="tooltip tooltip-sm tooltip-top-left"
    aria-label="top left direction"
  >
    <cds-icon shape="info-circle" size="24"></cds-icon>
    <span class="tooltip-content">Lorem ipsum sit</span>
  </a>
</div>
<app-code-snippet [code]="example2"></app-code-snippet>

<h4 cds-text="subsection medium" class="clr-mt-32px">Bottom-Right</h4>
<div class="clr-example squeeze example-center">
  <a
    href="javascript://"
    role="tooltip"
    aria-haspopup="true"
    class="tooltip tooltip-md tooltip-bottom-right"
    aria-label="bottom right direction"
  >
    <cds-icon shape="info-circle" size="24"></cds-icon>
    <span class="tooltip-content">Lorem ipsum dolor sit amet, ipsum</span>
  </a>
</div>
<app-code-snippet [code]="example3"></app-code-snippet>

<h4 cds-text="subsection medium" class="clr-mt-32px">Bottom-Left</h4>
<div class="clr-example squeeze example-center">
  <a
    href="javascript://"
    role="tooltip"
    aria-haspopup="true"
    class="tooltip tooltip-lg tooltip-bottom-left"
    aria-label="bottom left direction"
  >
    <cds-icon shape="info-circle" size="24"></cds-icon>
    <span class="tooltip-content">Lorem ipsum dolor sit amet, consectetur adipisicing elit</span>
  </a>
</div>
<app-code-snippet [code]="example4"></app-code-snippet>

<h4 cds-text="subsection medium" class="clr-mt-32px">Right</h4>
<div class="clr-example squeeze example-center">
  <a
    href="javascript://"
    role="tooltip"
    aria-haspopup="true"
    class="tooltip tooltip-right"
    aria-label="right direction"
  >
    <cds-icon shape="info-circle" size="24"></cds-icon>
    <span class="tooltip-content">Lorem ipsum dolor sit amet, ipsum</span>
  </a>
</div>
<app-code-snippet [code]="example5"></app-code-snippet>

<h4 cds-text="subsection medium" class="clr-mt-32px">Left</h4>
<div class="clr-example squeeze example-center">
  <a
    href="javascript://"
    role="tooltip"
    aria-haspopup="true"
    class="tooltip tooltip-sm tooltip-left"
    aria-label="left direction"
  >
    <cds-icon shape="info-circle" size="24"></cds-icon>
    <span class="tooltip-content">Lorem ipsum sit</span>
  </a>
</div>
<app-code-snippet [code]="example6"></app-code-snippet>
